import MultiDropDown from '@common/dropDown/multiDropDown';
import { JobGroupCode } from '@domain/constant/filterType';
import { ReactSelectOption } from '@domain/constant/ReactSelectOption';
import { useJobGroupList } from '@repository/codes/useCodes';
import { useCompanyQuestionList } from '@repository/interviewPractices/pooledQuestions/usePooledQuestions';
import { FC } from 'react';
import { useForm } from 'react-hook-form';
import {
  CompanyQuestionFilterName,
  CompanyQuestionListFilterOption,
  dropDownCareerOptions,
} from './questionListFilter';

import Dimm from '@components/pass/interview/common/dimm';
import { useUserInfo } from '@repository/auth/useUserInfo';
import useCheckAuthority from '@utils/hooks/useCheckAuthority';
import classNames from 'classnames/bind';
import InterviewPracticeQuestionList from '../../../common/questionList';
import style from './questionList.module.scss';
import Text from '@components/common/text';
import { FontStyle } from '@domain/constant/fontStyle';

const cx = classNames.bind(style);

const allJobGroupOption: ReactSelectOption[] = [{ value: -1, label: '직군 공통' }];

interface InterviewPracticeQuestionSelectCompanyQuestionListProps {
  selectedCompanySn: number | null;
}

const InterviewPracticeQuestionSelectCompanyQuestionList: FC<
  InterviewPracticeQuestionSelectCompanyQuestionListProps
> = ({ selectedCompanySn }) => {
  const { data: jobGroupListData } = useJobGroupList();
  const jobGroupListOptions = jobGroupListData?.jobTitleGroups.map((el) => ({ value: el.code, label: el.name })) ?? [];
  const { data: userInfo } = useUserInfo();
  const { isAuthorityUser } = useCheckAuthority(userInfo);
  const { watch, control } = useForm<CompanyQuestionListFilterOption>({
    defaultValues: new CompanyQuestionListFilterOption(),
  });
  const [jobTypeList, jobGroupList] = watch([
    CompanyQuestionFilterName.JOBTYPE,
    CompanyQuestionFilterName.JOBGROUP,
  ]) as any;
  const jobTypeCodes = jobTypeList?.map((it: any) => it.value) ?? [];
  const jobGroupCodes = jobGroupList?.map((it: any) => it.value) ?? [];

  const { data: companyQuestionList, isFetched } = useCompanyQuestionList(
    selectedCompanySn ?? 0,
    jobTypeCodes,
    jobGroupCodes as JobGroupCode[],
    {
      enabled: !!isAuthorityUser,
    },
  );

  const companyQuestionCount = companyQuestionList?.questions.length;
  if (isAuthorityUser && !isFetched) return null;

  return (
    <div className={cx('questionListWrap')}>
      <div className={cx('titleWrap')}>
        <div className={cx('title')}>
          기업별 예상 질문
          {isAuthorityUser && (
            <>
              <span className={cx('highlightText')}> {companyQuestionCount}</span>개
            </>
          )}
        </div>
        <div className={cx('btnWrap')}>
          <MultiDropDown
            className={cx('filterJobType')}
            control={control as any}
            name={CompanyQuestionFilterName.JOBTYPE}
            options={dropDownCareerOptions}
            placeholder={'신입・경력'}
          />
          <MultiDropDown
            className={cx('filterJobGroup')}
            control={control as any}
            name={CompanyQuestionFilterName.JOBGROUP}
            options={[
              { label: '', options: allJobGroupOption },
              { label: '총 11개 직군', options: jobGroupListOptions },
            ]}
            placeholder={'직군'}
          />
        </div>
      </div>

      {!isAuthorityUser && <Dimm style={{ marginTop: 16, width: 894, height: 690, padding: 10 }} />}

      {!isFetched && companyQuestionList?.questions.length === 0 ? (
        <div className={cx('emptyView')}>
          <div className={cx('emptyIcon')} />
          <Text fontStyle={FontStyle.B1_B} styles={{ marginTop: 16 }}>
            필터를 변경해 보세요.
          </Text>
          <Text fontStyle={FontStyle.B3_M} styles={{ marginTop: 8 }}>
            필터 조건을 해제하거나 다른 조건을 설정해 보세요
          </Text>
        </div>
      ) : (
        <InterviewPracticeQuestionList
          className={cx('questionList')}
          questionList={companyQuestionList?.questions ?? []}
        />
      )}
    </div>
  );
};

export default InterviewPracticeQuestionSelectCompanyQuestionList;
